module.exports = __webpack_public_path__ + "@/assets/img/santanderlogo.7a9424f5.png";